import React from "react";
const Error = () => {
  return <h4 className="title">There are some error!</h4>;
};

export default Error;
